import instance from './scorpiusInstance';
import {
  FETCH_USER_ATTRIBUTES_START,
  FETCH_USER_ATTRIBUTES_SUCCESS,
  FETCH_USER_ATTRIBUTES_ERROR,
} from './types';

const fetchAttributesStart = applicationName => ({
  type: FETCH_USER_ATTRIBUTES_START,
  payload: {
    applicationName,
  },
});

const fetchAttributesSuccess = (data, applicationName) => ({
  type: FETCH_USER_ATTRIBUTES_SUCCESS,
  payload: {
    data,
    applicationName,
  },
});

const fetchAttributesError = (error, applicationName) => ({
  type: FETCH_USER_ATTRIBUTES_ERROR,
  payload: {
    error,
    applicationName,
  },
});

export const fetchAttributes = applicationName => async dispatch => {
  dispatch(fetchAttributesStart(applicationName));
  try {
    const response = await instance.get('/user/attributes', {
      params: {
        application_name: applicationName,
      },
    });
    return dispatch(fetchAttributesSuccess(response.data, applicationName));
  } catch (error) {
    throw dispatch(fetchAttributesError(error, applicationName));
  }
};
